import { useEffect } from 'react';
import { useDashboardTheme } from './theme-api';
import { applyDashboardColors } from './config';

export function BrandThemeSync() {
  const { data } = useDashboardTheme();
  useEffect(() => {
    if (data) applyDashboardColors(data.colors);
  }, [data]);
  return null;
}
